







































import { Prop, Component, Vue } from "vue-property-decorator";
import { Project } from "@/api/project-api";
import { getWeatherNews, WeatherNews } from "@/api/weather-api";
import WeathersIcon from "@/components/WeathersIcon.vue";

import VProjectDropdown from "@/components/VProjectDropdown.vue";
import VProjectHeaderTitle from "@/components/VProjectHeaderTitle.vue";
import VIcon, { IconProps } from "../components/VIcon.vue";
import { isNewProject } from "@/preferences";
import StatusPage from "./StatusPage.vue";

@Component({
  components: {
    VIcon,
    VProjectDropdown,
    VProjectHeaderTitle,
    WeathersIcon,
    StatusPage
  },
  methods: {
    isNewProject
  }
})
export default class ProjectHeader extends Vue {
  @Prop({ required: true }) project!: Project;
  @Prop({ default: () => [] }) projects!: Project[];
  @Prop({ default: () => [] }) memberIcons!: IconProps[];

  getWeather() {
    const weathers = this.weatherNews.weatherNews;
    if (!weathers) return "";
    return weathers;
  }

  async created() {
    this.initWeatherNews();
  }
  get user() {
    return this.$store.getters.user;
  }

  weatherNews: WeatherNews = {
    place: "",
    latitude: "",
    longitude: "",
    weatherNews: []
  };

  async initWeatherNews() {
    this.weatherNews = await getWeatherNews(this.project.projectId);
  }

  listMembers() {
    this.$emit("listMembers");
  }
}
